import {connect} from 'react-redux';
import {View} from 'react-template';
class Login extends View  {

    constructor(props) {
        super(props);
        this.getURL();
        this.state = {loadToken: false}

        this.isIE()
    }
    
    getURL(){
        if(this.props.auth.loggedIn)
            this.props.router.push("/admin")
        else{
            window.location.href = process.env.REACT_APP_URL_API+'/redirect?url='+window.location.origin+process.env.REACT_APP_URL_PATH+'/admin'
        }
    }

    render() {
        return (
            null
        );
    }
}

function mapStateToProps(state) {
    return {auth: state.auth};
}

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/auth/components/Login.js